import { Injectable } from '@angular/core';

import { Assessment } from '../models/assessment';
import { Api } from './api';
import { Batteries } from '../models/batteries';

@Injectable()
export class Assessments {
  assessments: Assessment[];
  batteries: Batteries[];

  defaultItem: any = {
      "id": "84748",
      "user_id": "6324",
      "first_name": "Generic",
      "last_name": "Client",
      "sex_id": "3",
      "date_of_birth": "1800-01-01",
      "active": "1",
  };


  constructor(public api: Api) {

  }

  getAssessmentList(){
    let seq =  this.api.getAssessments('assessments', '1.0')
    seq
    .subscribe(res => {
        this.assessments = res;
    },
        err => {
            console.log(err);
        });
    return seq;
  }

  getBatteries(){
    let seq =  this.api.getBatteries('batteries')
    seq
    .subscribe(res => {
        this.batteries = res;
    },
        err => {
            console.log(err);
        });
    return seq;
  }

  getBatteryList(params?: any) {
    if (!params) {
        var sortedBatteries = this.batteries.sort(function(a,b){
            return a.name > b.name ? 1:a.name < b.name?-1:0
           })
        return sortedBatteries;
    }
    return this.batteries.filter((item) => {
            return (item.name.toLowerCase().indexOf(params.toLowerCase()) > -1 || item.description.toLowerCase().indexOf(params.toLowerCase()) > -1 );
     }
    )
    
}

  addBattery(battery){
    let seq =  this.api.addBattery('batteries', battery).share();
        seq
        .map(res => res.json().data.battery)
        .subscribe(res => {
          // If the API returned a successful response, push the response in the clientsList
          this.batteries.push(res);
        }, err => {
          console.error('ERROR', err);
        });

      return seq;
    // return this.api.addBattery('batteries', battery);

  }

  editBattery(battery, id) {
    return this.api.editBattery('batteries', battery, id)
  
}

deleteBattery(item:any, id:string) {
    this.batteries.splice(this.batteries.findIndex(i => i.id === item.id),1);
    return this.api.deleteBattery('batteries', item, id);
  }

  getAssessments(params?: any) {
      if (!params) {
          return this.assessments;
      }
      return this.assessments.filter((item) => {
              return (item.short_name.toLowerCase().indexOf(params.toLowerCase()) > -1 || item.extended_name.toLowerCase().indexOf(params.toLowerCase()) > -1);
       })
        
  }

  

  
}



// WEBPACK FOOTER //
// ./src/providers/assessments.ts